import type { InternalProduct } from 'components/discovery/product/tile-parts/tile-parts-typing.js'
import type { AnalyticsContext } from 'components/shared/analytics/analytics-types.js'

export const orderTemplateQuantity = (product: InternalProduct): number =>
  product.ordering.defaultOrderQuantityDec
    ?? product.ordering.defaultOrderQuantity
    ?? product.ordering.orderQuantityDec
    ?? product.ordering.orderQuantity
    ?? 1

export const orderTemplateTrackingContext = (index: number | undefined): AnalyticsContext =>
  index !== undefined ? { index } : {}
